/*--------------------------------------------------------------------------------------------------------------
 *  Copyright (c) insite-gmbh. All rights reserved.
 *  Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------------------------*/
import { NgModule } from '@angular/core';
import { ButtonMenuComponent } from './buttonMenu/buttonMenu.component';
import { ButtonMenuLineComponent } from './buttonMenuLine/buttonMenuLine.component';
import { MenuButtonComponent } from './menuButton/menuButton.component';
import { BrowserModule } from '@angular/platform-browser';

@NgModule({
    imports:
    [
        BrowserModule,
    ],
    exports:
    [
        ButtonMenuComponent,
    ],
    declarations:
    [
        ButtonMenuComponent,
        ButtonMenuLineComponent,
        MenuButtonComponent
    ],
    providers:
    [
        //ButtonMenuResourceManager, { provide: 'Window', useValue: window }
    ],
    bootstrap: []
})

export class ButtonMenuModule {
    //Resource manager adds the translations to the translationservice
    //constructor(private _resourceManager: ButtonMenuResourceManager ) {}
}